import classNames from "classnames";
import LabelWithHelp from "components/labelWithHelp/labelWithHelp.js";
import React, { useRef, useState } from "react";
import Lock from "../../../../../server/public/icons/Lock.js";
import "./style.css";
export default function TextInput(props) {
    var _a, _b, _c, _d;
    const [correctInfo, setCorrectInfo] = useState("");
    const [incorrectInfo, setIncorrectInfo] = useState("");
    const idRef = useRef(crypto.randomUUID());
    return (React.createElement("label", { className: classNames("input-label " + ((_a = props.classNames) !== null && _a !== void 0 ? _a : ""), "text-input-label", {
            "input-label-no-spacing": props.disableExtraSpacing,
            "input-label-with-before-input": props.beforeInput,
        }), htmlFor: idRef.current },
        React.createElement("div", { className: "text-input-label-container" }, props.disabled ?
            React.createElement(LabelWithHelp, { iconOverride: React.createElement(React.Fragment, null,
                    React.createElement(Lock, { width: 12 })), text: props.label, help: "Tej zawarto\u015Bci nie mo\u017Cna edytowa\u0107" })
            : props.label),
        React.createElement("div", { className: "text-input-wrapper" },
            props.beforeInput,
            React.createElement("input", { className: "text-input", placeholder: props.placeholder, hidden: props.hidden, 
                // eslint-disable-next-line react/no-unknown-property
                datatype: (_b = props.datatype) !== null && _b !== void 0 ? _b : "", disabled: props.disabled == true ? true : false, value: props.value, type: props.type, id: idRef.current, name: (_c = props.name) !== null && _c !== void 0 ? _c : "", autoComplete: props.autocomplete, onBlur: (event) => {
                    var _a;
                    (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, event.target.value);
                }, onChange: (event) => {
                    var _a, _b, _c;
                    const value = event.target.value;
                    setCorrectInfo("");
                    setIncorrectInfo("");
                    if (!props.validator) {
                        return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, value, true);
                    }
                    try {
                        const [isValid, result] = props.validator(value);
                        if (isValid)
                            setCorrectInfo(result);
                        if (!isValid)
                            setIncorrectInfo(result);
                        (_b = props.onChange) === null || _b === void 0 ? void 0 : _b.call(props, value, isValid);
                    }
                    catch (err) {
                        (_c = props.onChange) === null || _c === void 0 ? void 0 : _c.call(props, value, true);
                    }
                }, ...((_d = props.extraAttrs) !== null && _d !== void 0 ? _d : {}) })),
        correctInfo && React.createElement("span", { className: "info-correct" }, correctInfo),
        incorrectInfo && React.createElement("span", { className: "info-incorrect" }, incorrectInfo)));
}
